import React from 'react';
import { CookieWrapper, CookieText, AcceptCookieBtn, LinkStyle } from './CookieBanner.style';

var CookieBanner = function CookieBanner(_ref) {
  var acceptCookie = _ref.acceptCookie,
      denyCookie = _ref.denyCookie,
      cookiePolicyUrl = _ref.cookiePolicyUrl;
  return React.createElement(CookieWrapper, null, React.createElement(CookieText, {
    tag: "p",
    color: "white"
  }, "Hello! Comic Relief uses cookies to help make this website better and improve our services. You can learn more about", React.createElement(LinkStyle, {
    href: cookiePolicyUrl,
    type: "standard_white"
  }, "our use of cookies"), ". We also use optional cookies for marketing purposes:"), React.createElement(CookieText, {
    tag: "p",
    color: "white"
  }, React.createElement(AcceptCookieBtn, {
    href: "/comic",
    type: "button",
    color: "white",
    onClick: acceptCookie
  }, "Accept"), "Or click", React.createElement(LinkStyle, {
    href: "",
    type: "standard_white",
    onClick: denyCookie
  }, "here"), "to deny these."));
};

export default CookieBanner;